/* ============================================================
   Marble Product — gallery + variant selection + live pricing
   ============================================================ */
(function () {
  'use strict';

  /* ---------- money formatting (Shopify-style) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '{{amount}}';

    function defaultTo(num, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    switch ((fmt.match(placeholderRegex) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = defaultTo(cents, 0, ' ', ''); break;
      default: value = defaultTo(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  /* ---------- per-section init ---------- */
  function initSection(root) {
    if (root.dataset.mpInit) return;
    root.dataset.mpInit = '1';

    var moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-mp-variants]').textContent);
    } catch (e) { variants = []; }

    /* explicit inventory map — { variantId: { qty: number, tracked: boolean } } */
    var inventoryMap = {};
    try {
      var invEl = root.querySelector('[data-mp-inventory]');
      if (invEl) inventoryMap = JSON.parse(invEl.textContent || '{}');
    } catch (e) { inventoryMap = {}; }

    function handleize(str) {
      return String(str || '').toLowerCase().trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    /* ===== GALLERY ===== */
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mp-thumb]'));
    var current = 0;

    function groupOf(el) { return el.getAttribute('data-mp-group') || 'default'; }

    function visibleIndices() {
      var out = [];
      slides.forEach(function (s, i) {
        if (!s.classList.contains('is-hidden')) out.push(i);
      });
      return out;
    }

    function showSlide(i) {
      var vis = visibleIndices();
      if (!vis.length) return;
      if (vis.indexOf(i) === -1) i = vis[0];
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      current = i;
    }

    function step(dir) {
      var vis = visibleIndices();
      if (!vis.length) return;
      var pos = vis.indexOf(current);
      if (pos === -1) pos = 0;
      pos = (pos + dir + vis.length) % vis.length;
      showSlide(vis[pos]);
    }

    /* show only the image set for a stone; fall back to the 'default' set */
    function setImageGroup(group) {
      if (!slides.length) return;
      var hasGroup = slides.some(function (s) { return groupOf(s) === group; });
      var hasDefault = slides.some(function (s) { return groupOf(s) === 'default'; });
      var useGroup = hasGroup ? group : 'default';
      slides.forEach(function (s, i) {
        var on = (hasGroup || hasDefault) ? (groupOf(s) === useGroup) : true;
        s.classList.toggle('is-hidden', !on);
        if (thumbs[i]) thumbs[i].classList.toggle('is-hidden', !on);
      });
      var vis = visibleIndices();
      if (vis.length) showSlide(vis[0]);
    }

    var prevBtn = root.querySelector('[data-mp-prev]');
    var nextBtn = root.querySelector('[data-mp-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        showSlide(parseInt(t.dataset.mpThumb, 10));
      });
    });

    /* ----- swipe gestures on viewport (mobile) ----- */
    var viewport = root.querySelector('[data-mp-viewport]');
    if (viewport) {
      var SWIPE_THRESHOLD = 40;
      var startX = 0;
      var startY = 0;
      var tracking = false;

      viewport.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches[0]) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      viewport.addEventListener('touchend', function (e) {
        if (!tracking || !e.changedTouches || !e.changedTouches[0]) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          step(dx < 0 ? 1 : -1);
        }
      }, { passive: true });

      viewport.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
    }

    /* ===== VARIANT SELECTION ===== */
    var swatchBtns = Array.prototype.slice.call(root.querySelectorAll('[data-mp-swatch]'));
    var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-mp-size]'));
    var heightBtns = Array.prototype.slice.call(root.querySelectorAll('[data-mp-height]'));

    var stoneIdx = parseInt(root.dataset.stoneIdx || '0', 10);
    var sizeIdx = parseInt(root.dataset.sizeIdx || '0', 10);
    var heightIdx = parseInt(root.dataset.heightIdx || '0', 10);

    var hasStone = swatchBtns.length > 0 && stoneIdx > 0;
    var hasSize = sizeBtns.length > 0 && sizeIdx > 0;
    var hasHeight = heightBtns.length > 0 && heightIdx > 0;

    function vopt(v, idx) {
      if (idx === 1) return v.option1;
      if (idx === 2) return v.option2;
      if (idx === 3) return v.option3;
      return null;
    }

    var selected = {
      stone: hasStone ? (root.querySelector('[data-mp-swatch].is-selected') || swatchBtns[0]).dataset.mpValue : null,
      size: hasSize ? (root.querySelector('[data-mp-size].is-selected') || sizeBtns[0]).dataset.mpValue : null,
      height: hasHeight ? (root.querySelector('[data-mp-height].is-selected') || heightBtns[0]).dataset.mpValue : null
    };
    var lastStoneGroup = null;

    function variantMatches(v, stone, size, height) {
      if (hasStone && vopt(v, stoneIdx) !== stone) return false;
      if (hasSize && vopt(v, sizeIdx) !== size) return false;
      if (hasHeight && vopt(v, heightIdx) !== height) return false;
      return true;
    }
    function findVariant(stone, size, height) {
      for (var i = 0; i < variants.length; i++) {
        if (variantMatches(variants[i], stone, size, height)) return variants[i];
      }
      return null;
    }
    function minPriceWhere(predicate) {
      var min = null;
      variants.forEach(function (v) {
        if (predicate(v) && (min === null || v.price < min)) min = v.price;
      });
      return min;
    }

    var globalMin = minPriceWhere(function () { return true; });

    /* ----- DOM refs ----- */
    var variantInput = root.querySelector('[data-mp-variant-id]');
    var totalEl = root.querySelector('[data-mp-total]');
    var totalCompareEl = root.querySelector('[data-mp-total-compare]');
    var availabilityEl = root.querySelector('[data-mp-availability]');
    var availabilityDotEl = root.querySelector('[data-mp-availability-dot]');
    var availabilityTitleEl = root.querySelector('[data-mp-availability-title]');
    var availabilityEtaEl = root.querySelector('[data-mp-availability-eta]');

    function variantInStock(v) {
      if (!v) return false;
      // Brand source-of-truth for "in stock" is the `ready-to-ship` product tag, NOT inventory qty.
      // Made-to-order products carry positive inventory (999) only as a workaround for Shopify's
      // 0+CONTINUE /cart/add bug — they must still display as MADE TO ORDER, never IN STOCK.
      if (root.dataset.readyToShip !== 'true') return false;
      // For ready-to-ship products, distinguish per-variant: real stock vs. the 999 sentinel.
      // 999 means "purchasable via backorder workaround" - label as made-to-order, not in-stock.
      var mapped = inventoryMap[v.id];
      var qty = mapped ? (mapped.qty || 0) : (v.inventory_quantity || 0);
      return qty > 0 && qty < 999;
    }

    // Diagnostic: log inventory state once so we can verify the data is reaching JS
    if (window && window.console) {
      var stockSummary = Object.keys(inventoryMap).map(function (id) {
        return id + ':' + (inventoryMap[id].qty || 0) + (inventoryMap[id].tracked ? '(t)' : '(u)');
      }).join(' ');
      console.log('[Marbella] inventory map:', inventoryMap);
      console.log('[Marbella] inventory summary:', stockSummary || '(empty)');
    }

    function localizedString(key) {
      // labels resolved via dataset (passed from liquid) — simpler than carrying t() to JS
      return root.dataset[key] || '';
    }
    var stoneNameEl = root.querySelector('[data-mp-stone-name]');
    var stoneDeltaEl = root.querySelector('[data-mp-stone-delta]');
    var baseDeltaEl = root.querySelector('[data-mp-base-delta]');
    var atcBtn = root.querySelector('#AddToCart');
    var atcText = root.querySelector('[data-mp-atc-text]');

    function deltaLabel(cents) {
      if (cents == null) return '';
      if (cents <= 0) return '+' + formatMoney(0, moneyFormat);
      return '+' + formatMoney(cents, moneyFormat);
    }

    function refresh() {
      var v = findVariant(selected.stone, selected.size, selected.height);

      /* selected-state classes */
      swatchBtns.forEach(function (b) {
        b.classList.toggle('is-selected', b.dataset.mpValue === selected.stone);
      });
      sizeBtns.forEach(function (b) {
        b.classList.toggle('is-selected', b.dataset.mpValue === selected.size);
      });
      heightBtns.forEach(function (b) {
        b.classList.toggle('is-selected', b.dataset.mpValue === selected.height);
      });

      /* swap gallery image group when the stone changes */
      if (hasStone) {
        var stoneGroup = handleize(selected.stone);
        if (stoneGroup !== lastStoneGroup) {
          setImageGroup(stoneGroup);
          lastStoneGroup = stoneGroup;
        }
      }

      /* stone name + delta */
      if (stoneNameEl) stoneNameEl.textContent = selected.stone || '';
      if (stoneDeltaEl && hasStone) {
        var stoneMin = minPriceWhere(function (vr) { return vopt(vr, stoneIdx) === selected.stone; });
        var sd = (stoneMin != null && globalMin != null) ? stoneMin - globalMin : null;
        stoneDeltaEl.textContent = (sd && sd > 0) ? deltaLabel(sd) : '';
      }

      /* size card deltas (relative to cheapest size for current stone+height) */
      if (hasSize) {
        var sizeMin = null;
        sizeBtns.forEach(function (b) {
          var sv = findVariant(selected.stone, b.dataset.mpValue, selected.height);
          if (sv && (sizeMin === null || sv.price < sizeMin)) sizeMin = sv.price;
        });
        sizeBtns.forEach(function (b) {
          var deltaEl = b.querySelector('[data-mp-size-delta]');
          if (!deltaEl) return;
          var sv = findVariant(selected.stone, b.dataset.mpValue, selected.height);
          if (sv && sizeMin != null) {
            deltaEl.textContent = deltaLabel(sv.price - sizeMin);
            b.removeAttribute('disabled');
            b.style.opacity = '';
          } else {
            deltaEl.textContent = '';
          }
        });
      }

      /* size stock dots */
      if (hasSize) {
        sizeBtns.forEach(function (b) {
          var sv = findVariant(selected.stone, b.dataset.mpValue, selected.height);
          var dot = b.querySelector('[data-mp-size-stock-dot]');
          if (dot) {
            if (variantInStock(sv)) {
              dot.removeAttribute('hidden');
              b.classList.add('has-stock');
            } else {
              dot.setAttribute('hidden', 'hidden');
              b.classList.remove('has-stock');
            }
          }
        });
      }

      /* height stock dots */
      if (hasHeight) {
        heightBtns.forEach(function (b) {
          var hv = findVariant(selected.stone, selected.size, b.dataset.mpValue);
          var dot = b.querySelector('[data-mp-height-stock-dot]');
          if (dot) {
            if (variantInStock(hv)) {
              dot.removeAttribute('hidden');
              b.classList.add('has-stock');
            } else {
              dot.setAttribute('hidden', 'hidden');
              b.classList.remove('has-stock');
            }
          }
        });
      }

      /* base finish surcharge delta */
      if (baseDeltaEl) baseDeltaEl.textContent = (surcharges.base > 0) ? deltaLabel(surcharges.base) : '';

      /* total + add to cart (always enabled — see availability banner for status) */
      if (v) {
        var addOns = (surcharges.finish || 0) + (surcharges.edge || 0) + (surcharges.base || 0);
        var displayPrice = v.price + addOns;
        if (totalEl) totalEl.textContent = formatMoney(displayPrice, moneyFormat);
        if (totalCompareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            totalCompareEl.textContent = formatMoney(v.compare_at_price + addOns, moneyFormat);
            totalCompareEl.removeAttribute('hidden');
          } else {
            totalCompareEl.textContent = '';
            totalCompareEl.setAttribute('hidden', 'hidden');
          }
        }
        if (variantInput) variantInput.value = v.id;
        if (atcBtn) {
          atcBtn.removeAttribute('disabled');
          atcBtn.classList.remove('sold-out');
          if (atcText) atcText.textContent = root.dataset.atcLabel || atcText.textContent || 'Add to cart';
        }

        /* availability banner */
        if (availabilityEl) {
          var inStock = variantInStock(v);
          if (inStock) {
            availabilityEl.classList.remove('mp-availability--mto');
            availabilityEl.classList.add('mp-availability--stock');
            if (availabilityTitleEl) availabilityTitleEl.textContent = root.dataset.statusInStock || 'In stock';
            if (availabilityEtaEl) availabilityEtaEl.textContent = root.dataset.statusInStockEta || '';
          } else {
            availabilityEl.classList.remove('mp-availability--stock');
            availabilityEl.classList.add('mp-availability--mto');
            if (availabilityTitleEl) availabilityTitleEl.textContent = root.dataset.statusMadeToOrder || 'Made to order';
            if (availabilityEtaEl) availabilityEtaEl.textContent = root.dataset.statusMadeToOrderEta || '';
          }
          availabilityEl.removeAttribute('hidden');
        }
      } else {
        if (totalEl) totalEl.textContent = '—';
        if (availabilityEl) availabilityEl.setAttribute('hidden', 'hidden');
      }
    }

    swatchBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        selected.stone = b.dataset.mpValue;
        refresh();
      });
    });
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        selected.size = b.dataset.mpValue;
        refresh();
      });
    });
    heightBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        selected.height = b.dataset.mpValue;
        refresh();
      });
    });

    /* ===== FINISH / EDGE / BASE (line item properties) ===== */
    var surcharges = { finish: 0, edge: 0, base: 0 };

    function wireProperty(kind, groupSel, btnSel, inputSel, nameSel, surchargeInputSel) {
      var group = root.querySelector(groupSel);
      if (!group) return;
      var btns = Array.prototype.slice.call(group.querySelectorAll(btnSel));
      var input = root.querySelector(inputSel);
      var nameEl = root.querySelector(nameSel);
      var surchargeInput = surchargeInputSel ? root.querySelector(surchargeInputSel) : null;

      function applySurcharge(cents) {
        surcharges[kind] = cents;
        if (surchargeInput) surchargeInput.value = cents > 0 ? formatMoney(cents, moneyFormat) : '0';
      }

      var initial = group.querySelector(btnSel + '.is-selected') || btns[0];
      if (initial) applySurcharge(parseInt(initial.dataset.mpSurcharge || '0', 10));

      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          if (input) input.value = b.dataset.mpValue;
          if (nameEl) nameEl.textContent = b.dataset.mpValue;
          applySurcharge(parseInt(b.dataset.mpSurcharge || '0', 10));
          refresh();
        });
      });
    }
    wireProperty('finish', '[data-mp-finish-group]', '[data-mp-finish]', '[data-mp-finish-input]', '[data-mp-finish-name]', '[data-mp-finish-surcharge-input]');
    wireProperty('edge', '[data-mp-edge-group]', '[data-mp-edge]', '[data-mp-edge-input]', '[data-mp-edge-name]', '[data-mp-edge-surcharge-input]');
    /* base finish — round colour swatches, no surcharge, recorded as a line item property */
    wireProperty('base', '[data-mp-base-group]', '[data-mp-base]', '[data-mp-base-input]', '[data-mp-base-name]', null);

    /* ===== ADD-TO-CART INTERCEPT (bundle upgrades) ===== */
    var upgradeTier = root.dataset.upgradeTier || 'none';
    var form = root.querySelector('form[action*="/cart/add"]');
    var atc = root.querySelector('#AddToCart');

    function selectedUpgrades() {
      var ids = [];
      var map = (window.MARBELLA_UPGRADE_VARIANTS || {});

      /* premium base colour — flat surcharge, independent of product tier */
      var baseSel = root.querySelector('[data-mp-base].is-selected');
      if (baseSel && parseInt(baseSel.dataset.mpSurcharge || '0', 10) > 0 && map.base_premium) {
        ids.push(map.base_premium);
      }

      if (upgradeTier === 'none') return ids;

      var finishSel = root.querySelector('[data-mp-finish].is-selected');
      var edgeSel = root.querySelector('[data-mp-edge].is-selected');

      if (finishSel && /matt/i.test(finishSel.dataset.mpValue || '')) {
        var mId = map.matt && map.matt[upgradeTier];
        if (mId) ids.push(mId);
      }
      if (edgeSel && /round/i.test(edgeSel.dataset.mpValue || '')) {
        var rId = map.rounded && map.rounded[upgradeTier];
        if (rId) ids.push(rId);
      }
      return ids;
    }

    if (form && atc) {
      // capture phase = runs BEFORE the theme's <product-form> submit listener
      form.addEventListener('submit', function (e) {
        var upgrades = selectedUpgrades();

        // Debug visibility for setup issues
        if (upgrades.length === 0) {
          var anyMatt = !!root.querySelector('[data-mp-finish].is-selected[data-mp-value*="att"]');
          var anyRound = !!root.querySelector('[data-mp-edge].is-selected[data-mp-value*="ound"]');
          if ((anyMatt || anyRound) && upgradeTier === 'none') {
            console.warn('[Marbella] Matt/Rounded selected but product.type not set to Dining/Coffee/Side/Console/Night — surcharge will NOT be charged. Set product.type in Shopify admin.');
          }
          return; // no upgrades — let theme handle normally
        }

        // We're taking over: prevent the theme's product-form handler AND default submit
        e.preventDefault();
        e.stopImmediatePropagation();

        atc.classList.add('loading');
        atc.setAttribute('disabled', 'disabled');

        var mainId = (variantInput && variantInput.value) ? parseInt(variantInput.value, 10) : null;
        if (!mainId) { atc.classList.remove('loading'); atc.removeAttribute('disabled'); return; }

        var items = [{
          id: mainId,
          quantity: 1,
          properties: collectMainProperties()
        }];
        upgrades.forEach(function (id) {
          items.push({
            id: id,
            quantity: 1,
            properties: { '_bundle_parent': String(mainId) }
          });
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart add failed: ' + r.status);
            return r.json();
          })
          .then(function () {
            // Dispatch every known theme convention to refresh & open the cart drawer
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));

            // Habitat-specific: trigger the cart bubble/drawer via its custom element
            var cartBubble = document.querySelector('cart-bubble, [data-cart-bubble]');
            if (cartBubble && typeof cartBubble.refresh === 'function') cartBubble.refresh();

            // Programmatically open the cart drawer if present
            var drawer = document.querySelector('cart-drawer, [data-cart-drawer], #CartDrawer, .cart-drawer');
            if (drawer && drawer.classList) drawer.classList.add('is-open', 'open', 'active');

            // As a last resort if nothing opens, redirect to /cart
            setTimeout(function () {
              var anyOpen = document.querySelector('.cart-drawer.is-open, .cart-drawer.open, .cart-drawer.active, cart-drawer[open]');
              if (!anyOpen) window.location.href = '/cart';
            }, 600);
          })
          .catch(function (err) {
            console.error('[Marbella] cart add failed:', err);
            // fallback: native form post (theme handler is detached at this point)
            form.removeEventListener('submit', arguments.callee);
            form.submit();
          })
          .finally(function () {
            atc.classList.remove('loading');
            atc.removeAttribute('disabled');
          });
      }, true); // <-- capture
    }

    function collectMainProperties() {
      var props = {};
      var hiddenInputs = form ? form.querySelectorAll('input[type="hidden"][name^="properties["]') : [];
      Array.prototype.forEach.call(hiddenInputs, function (el) {
        var m = el.name.match(/^properties\[(.+)\]$/);
        if (m) props[m[1]] = el.value;
      });
      return props;
    }

    /* initial paint */
    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-marble-product]').forEach(initSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', boot);
})();
